import { handleActions } from 'redux-actions';
import { assocPath, pipe, pick } from 'ramda';

import {
  requestReportItem,
  requestReportItemSuccess,
  requestReportItemFailure,
  requestReportAttachment,
  requestReportAttachmentSuccess,
  requestReportAttachmentFailure,
  reportsSetObservation,
} from 'store/actionCreators/reports/singleItems';
import { requestObservationUpdateSuccess } from 'store/actionCreators/deviceStatuses';

const defaultState = {};

export default handleActions(
  {
    [requestReportItem]: (state, { payload: { id } }) => assocPath([id, 'loading'], true, state),
    [requestReportItemSuccess]: (
      state,
      {
        payload: { data, additionalDocuments },
        meta: {
          primaryPayload: { id },
        },
      },
    ) =>
      pipe(
        assocPath([id, 'loading'], false),
        assocPath([id, 'data'], data),
        assocPath([id, 'additionalDocuments'], additionalDocuments),
      )(state),
    [requestObservationUpdateSuccess]: (
      state,
      {
        payload: { response },
        meta: {
          primaryPayload: { id },
        },
      },
    ) => assocPath([id, 'data'], response, state),
    [requestReportItemFailure]: (
      state,
      {
        meta: {
          primaryPayload: { id },
        },
      },
    ) => pick([id], state),

    [requestReportAttachment]: (state, { payload: { reportId } }) =>
      assocPath([reportId, 'attachmentLoading'], true, state),
    [requestReportAttachmentSuccess]: (
      state,
      {
        meta: {
          primaryPayload: { reportId },
        },
      },
    ) => assocPath([reportId, 'attachmentLoading'], false, state),
    [requestReportAttachmentFailure]: (
      state,
      {
        meta: {
          primaryPayload: { reportId },
        },
      },
    ) => assocPath([reportId, 'attachmentLoading'], false, state),
    [reportsSetObservation]: (state, { payload: { id, data } }) =>
      assocPath([id, 'data'], data, state),
  },
  defaultState,
);
